import type { IconData } from '@stacksjs/iconify-core'

export const locationPinRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.432 21.501c0-9.213 7.403-16.653 16.5-16.653s16.5 7.44 16.5 16.653c0 5.334-2.437 9.896-5.614 13.579c-3.179 3.685-6.986 6.354-9.422 7.847a2.76 2.76 0 0 1-2.929 0c-2.435-1.493-6.243-4.162-9.422-7.847c-3.177-3.683-5.613-8.245-5.613-13.579M23.932.848c-11.338 0-20.5 9.262-20.5 20.653c0 6.616 3.03 12.071 6.584 16.191c3.553 4.118 7.74 7.04 10.361 8.645a6.76 6.76 0 0 0 7.11 0c2.62-1.606 6.808-4.527 10.36-8.645c3.554-4.12 6.585-9.575 6.585-16.191c0-11.39-9.163-20.653-20.5-20.653m-8.75 19.97a8.818 8.818 0 1 1 17.636 0a8.818 8.818 0 0 1-17.636 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPinRemix
